import { createSelector } from 'reselect'
import { selectVisibleRaids } from "./raids";
import {GymMembershipTypes} from "../filterSlice";

const getGyms = state => state.marker.gyms;
const getShowGyms = state => state.filter.showGyms;
const getGymTeam = state => state.filter.gymTeam;
const getGymStagnationDays = state => state.filter.gymStagnationDays;
const getGymMembership = state => state.filter.gymMembership;
const getGoldBadge = state => state.filter.goldBadge;
const getGymOpenSpotsOnly = state => state.filter.gymOpenSpotsOnly;
const getGymExFilter = state => state.filter.gymExFilter;
const getBadges = state => state.core.badges;
const getDefenders = state => state.defenders.defenders;
const getBounds = state => state.map.mapBounds;
const getHidden = state => state.marker.hidden;

export const selectVisibleGyms = createSelector(
	[getBounds, getShowGyms, getGyms, getGymTeam, getGymStagnationDays, getGymMembership, getGoldBadge, getBadges, getDefenders, getGymOpenSpotsOnly, getGymExFilter, selectVisibleRaids, getHidden],
	(bounds, showGyms, gyms, gymTeam, gymStagnationDays, gymMembership, goldBadge, badges, defenders, openSpotsOnly, exFilter, visibleRaids, hidden) => {
		if( !showGyms )
			return [];

		let list = Object.values(gyms);

		list = list.filter(gym =>
			gym.latitude  < bounds[0][0] && gym.latitude  > bounds[1][0] &&
			gym.longitude < bounds[0][1] && gym.longitude > bounds[1][1]
		);

		list = list.filter(gym => !visibleRaids.find(raid => raid.gym_id === gym.gym_id));

		if( gymTeam )
			list = list.filter(gym => gym.team_id === gymTeam);

		// if( gymStagnationDays )
		// 	list = list.filter(gym => gym.stable_days > gymStagnationDays);

		if( goldBadge === 1 )
			list = list.filter(gym => badges[gym.gym_id] !== 4);
		else if( goldBadge === 2 )
			list = list.filter(gym => badges[gym.gym_id] === 4);

		if( gymMembership === GymMembershipTypes.AM_MEMBER )
			list = list.filter(gym => defenders.includes(gym.gym_id));
		else if( gymMembership === GymMembershipTypes.AM_NOT_MEMBER )
			list = list.filter(gym => !defenders.includes(gym.gym_id));

		if( openSpotsOnly )
			list = list.filter(gym => gym.slots_available > 0);

		if( exFilter )
			list = list.filter(gym => gym['park']);

		if( Object.entries(hidden).length )
			list = list.filter(gym => !hidden['gym-' + gym.gym_id]);

		return list;
	}
);
